export default __webpack_public_path__ + "static/media/logo.d3bb9b2f.svg";